import React from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { ReactComponent as LeftIcon } from '@assets/images/arrow-left.svg';
import { ReactComponent as NavbarMenu } from '@assets/images/navbar-menu.svg';
import { useNavigationBarStore } from '@stores/navigationBarStore';
import './MobileNavBar.scss';

export type MobileNavBarProps = {
  fixed?: boolean;
  title?: React.ReactNode;
  leftButtonType?: 'menu' | 'back';
  leftButton?: React.ReactNode;
  rightButtonType?: 'login';
  rightButton?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

export const MobileNavBar: React.FC<MobileNavBarProps> = (props) => {
  const {
    fixed,
    title = '아이고고 파트너스',
    leftButtonType = 'menu',
    leftButton,
    rightButton,
    rightButtonType,
    className,
  } = props;
  const navigate = useNavigate();
  const { toggleSider } = useNavigationBarStore();

  const handleLeftButtonClick = () => {
    if (leftButtonType === 'menu') {
      toggleSider();
    } else if (leftButtonType === 'back') {
      navigate(-1);
    }
  };

  return (
    <>
      {fixed && <div className="mobile-nav-bar__fixed-empty" />}
      <header className={classNames('mobile-nav-bar', fixed && 'mobile-nav-bar__fixed', className)} style={props.style}>
        <div className="mobile-nav-bar__left">
          {(leftButtonType === 'menu' || leftButtonType === 'back') && (
            <button className="link-button" onClick={handleLeftButtonClick}>
              {leftButton && leftButton}
              {leftButton === undefined && leftButtonType === 'menu' && <NavbarMenu />}
              {leftButton === undefined && leftButtonType === 'back' && <LeftIcon />}
            </button>
          )}
        </div>
        <div className="mobile-nav-bar__center">{title}</div>
        <div className="mobile-nav-bar__right">
          {rightButton && rightButton}
          {rightButton === undefined && rightButtonType === 'login' && (
            <button
              className="link-button"
              style={{
                color: 'var(--Primary-95, #FF3D8F)',
                textAlign: 'center',
                fontFamily: 'Pretendard',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: 600,
                flexShrink: 0,
              }}
              onClick={() => {
                navigate('/login');
              }}>
              로그인
            </button>
          )}
        </div>
      </header>
    </>
  );
};
